export default "__VITE_ASSET__1iWWmuzq__"